import TextInput from 'components/atoms/form/TextInput/TextInput'
import Card from 'components/molecules/Card/Card'
import FormFooter from 'components/organisms/Form/FormFooter/FormFooter'
import { Form, Formik } from 'formik'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { NavLink } from 'react-router-dom'
import GuaranteeCancelPolicyService from 'services/GuaranteeCancelPolicyService'
import * as Yup from 'yup'
import * as FormConst from '../../../../constants/FormConst'
import RouteConst from '../../../../constants/RouteConst'
import SessionConst from '../../../../constants/SessionConst'
import SideNavEntryMapping from '../../../../constants/SideNavEntryMapping'
import { asyncMethod } from '../../../../redux/actions'
import * as actionTypes from '../../../../redux/actionTypes'
import {addDaysToDate, addYearsToDate, getCurrentDate, getCurrentDateString, getDateFromDateString, getDateStringFromDate, getGapsInDateRanges, isArrayNotEmpty, isObjectEmpty, multipleDateRangeOverlaps, searchFirstObjectInList, sortObjectList, isCompletedHotelInfoHistory} from '../../../../utilities/JSUtil'
import { getSessionItem } from '../../../../utilities/SessionHelper'
import Button from '../../../atoms/Button/Button'
import SelectInput from '../../../atoms/form/SelectInput/SelectInput'
import FormModal from '../../../organisms/FormModal/FormModal'
import withFormLayout from '../WithFormLayout'
import './GuaranteeAndCancelPolicyWithSeasons.scss'

class GuaranteeAndCancelPolicyWithSeasons extends Component {

    daysOfWeek = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday']
    daysOfWeekLabels = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']

    constructor(props) {
        super(props)
        const hotelInfoCompletedHistory = getSessionItem(SessionConst.HOTEL_INFO_COMPLETED_HISTORY);

        this.state = {
            hotelCode: getSessionItem(SessionConst.HOTEL_CODE),
            hotelInfo: getSessionItem(SessionConst.HOTEL_INFO),
            initialValues: this.initialValues,
            showDescriptions: false,
            hotelInfoCompletedHistory: hotelInfoCompletedHistory
        }
    }

    initialValues = {
        seasons: [
            {
                startDate: getCurrentDateString(),
                endDate: getDateStringFromDate(addYearsToDate(getCurrentDate(), FormConst.MIN_YEARS_GUARANTEE_CANCEL_POLICY_DEFAULT)),
                policies: [
                    {
                        guaranteePolicy: '',
                        cancelPolicy: '',
                        monday: true,
                        tuesday: true,
                        wednesday: true,
                        thursday: true,
                        friday: true,
                        saturday: true,
                        sunday: true
                    }
                ]
            }
        ]
    }

    validationSchema = Yup.object().shape({
        seasons: Yup.array().of(
            Yup.object().shape({
                startDate: Yup.date().test('Check start date', 'Start date is required', function (startDate) {
                   if (!startDate) {
                        return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED })
                    } else if (Date.parse(startDate) < Date.parse(getCurrentDateString())) {
                        return this.createError({ message: FormConst.VALIDATION_ERROR_MIN_START_DATE })
                    }

                    return true
                }),
                endDate: Yup.date().test('Check end date', 'End date is required', function (endDate) {
                    var startDate = this.parent.startDate;
                    if (!endDate) {
                        return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED })
                    } else if (Date.parse(endDate) < Date.parse(getCurrentDateString())) {
                        return this.createError({ message: FormConst.VALIDATION_ERROR_MIN_START_DATE })
                    } else if (startDate !== undefined && Date.parse(endDate) < addDaysToDate(Date.parse(startDate),  1)) {
                        return this.createError({ message: "End date should be after start date" })
                    } else if (startDate !== undefined && Date.parse(endDate) > addDaysToDate(Date.parse(startDate),  FormConst.MAX_YEARS_END_DATE*365)) {
                        return this.createError({ message: FormConst.VALIDATION_ERROR_MAX_END_DATE })
                    }
                    return true
                }),
                policies: Yup.array().of(
                    Yup.object().shape({
                        guaranteePolicy: Yup.string().required(FormConst.VALIDATION_ERROR_REQUIRED),
                        cancelPolicy: Yup.string().required(FormConst.VALIDATION_ERROR_REQUIRED),
                        monday: Yup.boolean().required(FormConst.VALIDATION_ERROR_REQUIRED),
                        tuesday: Yup.boolean().required(FormConst.VALIDATION_ERROR_REQUIRED),
                        wednesday: Yup.boolean().required(FormConst.VALIDATION_ERROR_REQUIRED),
                        thursday: Yup.boolean().required(FormConst.VALIDATION_ERROR_REQUIRED),
                        friday: Yup.boolean().required(FormConst.VALIDATION_ERROR_REQUIRED),
                        saturday: Yup.boolean().required(FormConst.VALIDATION_ERROR_REQUIRED),
                        sunday: Yup.boolean().required(FormConst.VALIDATION_ERROR_REQUIRED)
                    }).test('Check days of week that apply to a policy',
                        'All policies must apply to at least one day of week',
                        (policy) => {
                            // Check if at least one day of week is selected for the policy
                            let isDOWSelectedForPolicy = false
                            this.daysOfWeek.forEach(dayOfWeek => {
                                if (policy[dayOfWeek]) {
                                    isDOWSelectedForPolicy = true
                                }
                            })
                            return isDOWSelectedForPolicy
                        })
                )
            }).test('Days of week check for policies in a season', function (season) {
                let policiesDOWError
                let daysOfWeekSelectedCount = {
                    monday: 0,
                    tuesday: 0,
                    wednesday: 0,
                    thursday: 0,
                    friday: 0,
                    saturday: 0,
                    sunday: 0
                }

                season.policies.forEach(policy => {
                    // Update days of week selected count
                    for (const day in daysOfWeekSelectedCount) {
                        if (Object.hasOwnProperty.call(daysOfWeekSelectedCount, day)) {
                            if (policy[day]) {
                                daysOfWeekSelectedCount[day] += 1
                            }
                        }
                    }
                })

                // If any object in days of week count is not 1, then set error
                for (const day in daysOfWeekSelectedCount) {
                    if (Object.hasOwnProperty.call(daysOfWeekSelectedCount, day)) {
                        const count = daysOfWeekSelectedCount[day]
                        if (count === 0) {
                            policiesDOWError = 'All days of week must be selected at least once in a season'
                        } else if (count > 1) {
                            policiesDOWError = 'All days of week must be selected only once in a season'
                        }
                    }
                }

                // If there is an error, return the error
                if (!!policiesDOWError) {
                    return this.createError({ message: policiesDOWError })
                }
                return true
            })
        ).test('Seasons dates test', function (seasons) {
            if (seasons.length > 1) {
                let dateRanges = []
                seasons.forEach(season => {
                    if (season.startDate && season.endDate) {
                        dateRanges.push({
                            startDate: season.startDate,
                            endDate: season.endDate
                        })
                    }
                })
                let overlappingDateRanges = multipleDateRangeOverlaps(dateRanges)
                if (isArrayNotEmpty(overlappingDateRanges)) {
                    return this.createError({
                        message: `There are overlapping date ranges for seasons: 
                    [${getDateStringFromDate(overlappingDateRanges[0].startDate)}, ${getDateStringFromDate(overlappingDateRanges[0].endDate)}] 
                    and 
                    [${getDateStringFromDate(overlappingDateRanges[1].startDate)}, ${getDateStringFromDate(overlappingDateRanges[1].endDate)}]`
                    })
                } else if (isArrayNotEmpty(getGapsInDateRanges(dateRanges))) {
                    const gaps = getGapsInDateRanges(dateRanges)
                    return this.createError(
                        {
                            message: `There are gaps in date ranges for seasons: `
                                + gaps.map(gap => getDateStringFromDate(gap.startDate) + ' to ' + getDateStringFromDate(gap.endDate)).join(', ')
                        })
                }
            }
            return true
        })
    })

    async componentDidMount() {
        if (isCompletedHotelInfoHistory(this.state.hotelInfoCompletedHistory)) {
            let guaranteeCancelPolicies = this.state.hotelInfoCompletedHistory.newEntity.guaranteeCancelPolicies;
            this.setState({ isLoading: false, initialValues: this.buildFormValues(guaranteeCancelPolicies) })
        } else {
            await GuaranteeCancelPolicyService.getGuaranteeCancelPolicy({ hotelCode: this.state.hotelCode })
                .then(response => {
                    this.setState({ isLoading: false, initialValues: this.buildFormValues(response) })
                }).catch(error => {
                    this.setState({
                        isLoading: false,
                        showErrorModal: true,
                        errorMessage: 'There was an error while retrieving Guarantee and Cancel Policy data'
                    })
                })
        }
    }

    buildFormValues = (guaranteeCancelPolicyResponse) => {
        const guaranteeCancelPolicies = guaranteeCancelPolicyResponse.guaranteeCancelPolicies
        let seasons = []

        if (isArrayNotEmpty(guaranteeCancelPolicies)) {
            guaranteeCancelPolicies.forEach(guaranteeCancelPolicyObject => {
                let season = {
                    startDate: guaranteeCancelPolicyObject.dateRange?.startDate,
                    endDate: guaranteeCancelPolicyObject.dateRange?.endDate
                }
                const guaranteePolicyObject = searchFirstObjectInList('policyType', FormConst.POLICY_TYPE_GUARANTEE_POLICY, guaranteeCancelPolicyObject?.policies)
                const cancelPolicyObject = searchFirstObjectInList('policyType', FormConst.POLICY_TYPE_CANCEL_POLICY, guaranteeCancelPolicyObject?.policies)

                const gcpObject = {
                    'monday': guaranteePolicyObject['monday'] + '_' + cancelPolicyObject['monday'],
                    'tuesday': guaranteePolicyObject['tuesday'] + '_' + cancelPolicyObject['tuesday'],
                    'wednesday': guaranteePolicyObject['wednesday'] + '_' + cancelPolicyObject['wednesday'],
                    'thursday': guaranteePolicyObject['thursday'] + '_' + cancelPolicyObject['thursday'],
                    'friday': guaranteePolicyObject['friday'] + '_' + cancelPolicyObject['friday'],
                    'saturday': guaranteePolicyObject['saturday'] + '_' + cancelPolicyObject['saturday'],
                    'sunday': guaranteePolicyObject['sunday'] + '_' + cancelPolicyObject['sunday'],
                }

                let gcpSet = new Set()
                for (const day in gcpObject) {
                    if (Object.hasOwnProperty.call(gcpObject, day)) {
                        const gcpValue = gcpObject[day];
                        gcpSet.add(gcpValue)
                    }
                }

                season.policies = []
                gcpSet.forEach(gcpSetEntry => {
                    const guarantee_cancel = gcpSetEntry.split('_')
                    const guarantee = guarantee_cancel[0]
                    const cancel = guarantee_cancel[1]
                    season.policies.push({
                        guaranteePolicy: guarantee,
                        cancelPolicy: cancel,
                        monday: gcpObject['monday'] === gcpSetEntry,
                        tuesday: gcpObject['tuesday'] === gcpSetEntry,
                        wednesday: gcpObject['wednesday'] === gcpSetEntry,
                        thursday: gcpObject['thursday'] === gcpSetEntry,
                        friday: gcpObject['friday'] === gcpSetEntry,
                        saturday: gcpObject['saturday'] === gcpSetEntry,
                        sunday: gcpObject['sunday'] === gcpSetEntry,
                    })
                })
                seasons.push(season)

            })
            sortObjectList(seasons, 'startDate')
        } else {
            seasons = [
                {
                    startDate: getCurrentDateString(),
                    endDate: getDateStringFromDate(addYearsToDate(getCurrentDate(), FormConst.MIN_YEARS_GUARANTEE_CANCEL_POLICY_DEFAULT)),
                    policies: [{
                        guaranteePolicy: '',
                        cancelPolicy: '',
                        monday: true,
                        tuesday: true,
                        wednesday: true,
                        thursday: true,
                        friday: true,
                        saturday: true,
                        sunday: true,
                    }]
                }
            ]
        }
        return {
            seasons: seasons
        }
    }

    getCancelPolicyOptions = (guaranteePolicy) => {
        return guaranteePolicy ? FormConst.GUARANTEE_POLICY_TO_CANCEL_POLICY_MAPPING[guaranteePolicy].map(cancelPolicy => {
            return {
                label: cancelPolicy,
                value: cancelPolicy
            }
        }) : [{ label: '', value: '' }]
    }

    addPolicyToSeason = (seasons, seasonIndex) => {
        seasons[seasonIndex].policies.push({
            guaranteePolicy: '',
            cancelPolicy: '',
            sunday: false,
            monday: false,
            tuesday: false,
            wednesday: false,
            thursday: false,
            friday: false,
            saturday: false,
        })
        this.setState({
            initialValues: {
                seasons: seasons
            }
        })
    }

    deletePolicyFromSeason = (seasons, seasonIndex, policyIndex) => {
        seasons[seasonIndex].policies.splice(policyIndex, 1)
        this.setState({
            initialValues: {
                seasons: seasons
            }
        })
    }

    addSeason = (seasons) => {
        let newSeasonStartDate = ''
        let newSeasonEndDate = ''

        // If the preceding season has an end date, then use it to set the start date of new season
        const seasonsLength = seasons.length
        if (seasonsLength > 0) {
            const lastSeason = seasons[seasonsLength - 1]
            if (lastSeason?.endDate) {
                newSeasonStartDate = getDateStringFromDate(addDaysToDate(getDateFromDateString(lastSeason.endDate), 1))
            }
        }

        seasons.push({
            startDate: newSeasonStartDate,
            endDate: newSeasonEndDate,
            policies: [
                {
                    guaranteePolicy: '',
                    cancelPolicy: '',
                    monday: true,
                    tuesday: true,
                    wednesday: true,
                    thursday: true,
                    friday: true,
                    saturday: true,
                    sunday: true
                }
            ]
        })
        this.setState({
            initialValues: {
                seasons: seasons
            }
        })
    }

    deleteSeason = (seasons, seasonIndex) => {
        seasons.splice(seasonIndex, 1)
        this.setState({
            initialValues: {
                seasons: seasons
            }
        })
    }

    handleSubmit = (formData) => {
        let guaranteeCancelPolicies = []

        formData.seasons.forEach(season => {

            let guaranteePolicy = {
                policyType: FormConst.POLICY_TYPE_GUARANTEE_POLICY
            }

            let cancelPolicy = {
                policyType: FormConst.POLICY_TYPE_CANCEL_POLICY
            }

            season.policies.forEach(policy => {
                this.daysOfWeek.forEach(day => {
                    if (policy[day]) {
                        guaranteePolicy[day] = policy.guaranteePolicy
                        cancelPolicy[day] = policy.cancelPolicy
                    }
                })
            })

            let putSeason = {
                dateRange: {
                    startDate: season.startDate,
                    endDate: season.endDate
                },
                policies: [guaranteePolicy, cancelPolicy]
            }

            guaranteeCancelPolicies.push(putSeason)
        })
        this.props.onPut({
            hotelCode: this.state.hotelCode,
            guaranteeCancelPolicies: guaranteeCancelPolicies
        })
        this.setState({ isLoading: true, loadingMessage: FormConst.MODAL_UPDATE_ACTION_TEXT })
    }

    componentDidUpdate(prevProps) {
        if (prevProps.count !== this.props.count) {
            if (this.props.errorMessage) {
                this.setState({
                    isLoading: false,
                    errorMessage: this.props.errorDescription,
                    showErrorModal: true
                })
            } else {
                // Continue to next form
                if (this.state.continueFlow) {
                    // Go to the next page
                    this.props.history.push({
                        pathname: RouteConst.ROUTE_PET_POLICY_PAGE,
                        state: {
                            continueFlow: this.state.continueFlow
                        }
                    })
                } else {
                    // Go back to hotel policies page
                    this.props.history.push(RouteConst.ROUTE_POLICIES_PAGE)
                }
            }
        }
    }

    handleKeyDown = (event) => {
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          event.preventDefault();
        }
    };

    render() {
        var today = new Date();
        var dd = today.getDate();
        var mm = today.getMonth() + 1;
        var yyyy = today.getFullYear();
        if (dd < 10) {
            dd = '0' + dd
        }
        if (mm < 10) {
            mm = '0' + mm
        }
        today = yyyy + '-' + mm + '-' + dd;

        return (
            <div className='guarantee-cancel-policies-page-with-seasons'>
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><NavLink to={RouteConst.ROUTE_HOME_PAGE}>Home</NavLink></li>
                        <li className="breadcrumb-item"><NavLink to={RouteConst.ROUTE_POLICIES_PAGE}>Policies</NavLink></li>
                        <li className="breadcrumb-item active" aria-current="page">Guarantee And Cancel Policy</li>
                    </ol>
                </nav>
                <div className='d-block d-xl-none'>
                    {FormConst.PAGE_NOT_ACCESSIBLE_ON_DEVICE}
                </div>
                <div className='d-none d-xl-block'>
                    <div id='guarantee-cancel-policies-helper-text'>
                        <p className='helper-text'>This section is to submit Guarantee and Cancel Policy details.</p>
                        <Button
                            id='descriptions-widget-link'
                            role='link'
                            name={this.state.showDescriptions ? 'Hide Policy Descriptions' : 'Show Policy Descriptions'}
                            onClick={() => this.setState({ showDescriptions: !this.state.showDescriptions })} />
                        {
                            this.state.showDescriptions
                            && <Card id='descriptions-widget'
                                header={
                                    <>
                                        Guarantee and Cancel Policy descriptions
                                    <button id='close-button' type='button' className='close' aria-label='Close'
                                            onClick={() => this.setState({ showDescriptions: false })}>
                                            <span aria-hidden='true'>&times;</span>
                                        </button>
                                    </>
                                }
                                text={
                                    <>
                                        <ul>
                                            <li>6P - 6 P.M. Hold</li>
                                            <li>4P - 4 P.M. Hold</li>
                                            <li>CCO - Credit Card Only</li>
                                            <li>GTD - Guarantee required</li>
                                            {/* <li>KGT - Kiosk Guarantee</li> */}
                                            <li>DEP - Room deposit for 1 night</li>
                                            <li>PPD - Prepayment required</li>
                                            <li>H - Hours</li>
                                            <li>D - Days</li>
                                        </ul>
                                        If you have questions or need assistance determining Guarantee and Cancel policies,
                                        please contact your {FormConst.LABEL_HOTEL_CONTACT_TYPE_OPENING_SERVICE_DIRECTOR}.
                                    </>
                                } />
                        }
                    </div>
                    <Formik
                        initialValues={this.state.initialValues}
                        validationSchema={this.validationSchema}
                        enableReinitialize={true}
                        onSubmit={(data, { setSubmitting, resetForm }) => {
                            setSubmitting(true)
                            this.handleSubmit(data)
                            setSubmitting(false)
                        }}
                        onReset={this.handleReset}>
                        {({ values, isSubmitting, isValid, handleChange, handleSubmit, setFieldValue, handleBlur, errors, touched }) => (
                            <Form className='guarantee-cancel-policies-form-element'>
                                <div className='guarantee-cancel-policies-form-fields'>
                                    <table className='table guarantee-cancel-policies-table'>
                                        <thead>
                                            <tr>
                                                <th>Start Date</th>
                                                <th>End Date</th>
                                                <th>Guarantee</th>
                                                <th>Cancel</th>
                                                <th className='text-center'>Applies to</th>
                                                <th colSpan={2}>Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                values.seasons.length === 0 ?
                                                    <tr>
                                                        <td colSpan={7} className='text-center'>There are no associated policies.</td>
                                                    </tr>
                                                    : values.seasons?.map((season, index) => (
                                                        <React.Fragment key={`season-${index}`}>
                                                            {
                                                                season.policies?.map((policy, policyIndex) => (
                                                                    <React.Fragment key={`season-${index}-policy-${policyIndex}`}>
                                                                        <tr className={index % 2 === 0 ? 'cell-dark' : 'cell-light'} key={`season-${index}-policy-${policyIndex}-details`}>
                                                                            <td>
                                                                                {
                                                                                    <TextInput
                                                                                        id={`start-date-${index}`} type='date'
                                                                                        min={today}
                                                                                        name={`seasons.${index}.startDate`}
                                                                                        disabled={policyIndex !== 0}
                                                                                        onKeyDown={(e) => this.handleKeyDown(e)}
                                                                                        title='Start Date' />
                                                                                }
                                                                            </td>
                                                                            <td>
                                                                                {
                                                                                    <TextInput
                                                                                        id={`end-date-${index}`} type='date'
                                                                                        min={today}
                                                                                        name={`seasons.${index}.endDate`}
                                                                                        disabled={policyIndex !== 0}
                                                                                        onKeyDown={(e) => this.handleKeyDown(e)}
                                                                                        title='End Date' />}
                                                                            </td>
                                                                            <td>
                                                                                <SelectInput
                                                                                    id={`guarantee-policy-${policyIndex}`}
                                                                                    name={`seasons.${index}.policies.${policyIndex}.guaranteePolicy`}
                                                                                    options={FormConst.GUARANTEE_POLICY_OPTIONS}
                                                                                    title='Guarantee' />
                                                                            </td>
                                                                            <td>
                                                                                <SelectInput
                                                                                    id={`cancel-policy-${policyIndex}`}
                                                                                    name={`seasons.${index}.policies.${policyIndex}.cancelPolicy`}
                                                                                    options={this.getCancelPolicyOptions(policy.guaranteePolicy)}
                                                                                    title='Cancel' />
                                                                            </td>
                                                                            <td>
                                                                                {
                                                                                    this.daysOfWeek.map((day, dayIndex) => (
                                                                                        <TextInput
                                                                                            type='checkbox'
                                                                                            id={`season-${index}-policy-${policyIndex}-day-of-week-${dayIndex}`}
                                                                                            label={this.daysOfWeekLabels[dayIndex].substring(0, 3)}
                                                                                            name={`seasons.${index}.policies.${policyIndex}.${day}`}
                                                                                            checked={policy[day]}
                                                                                            key={`season-${index}-policy-${policyIndex}-${day}-${dayIndex}`}
                                                                                            title='Applies To' />
                                                                                    ))
                                                                                }
                                                                                {
                                                                                    // Days of week error for policy within a season
                                                                                    !isObjectEmpty(errors)
                                                                                    && isArrayNotEmpty(errors.seasons)
                                                                                    && !isObjectEmpty(errors.seasons[index])
                                                                                    && isArrayNotEmpty(errors.seasons[index].policies)
                                                                                    && typeof (errors.seasons[index].policies[policyIndex]) === 'string'
                                                                                    && <span className='error'>
                                                                                        {errors.seasons[index].policies[policyIndex]}
                                                                                    </span>
                                                                                }
                                                                            </td>
                                                                            <td>
                                                                                {
                                                                                    policyIndex === 0
                                                                                        ? <Button role='link' name='Add Policy' onClick={() => this.addPolicyToSeason(values.seasons, index)} />
                                                                                        : <Button role='link' name='Delete Policy' onClick={() => this.deletePolicyFromSeason(values.seasons, index, policyIndex)} />
                                                                                }
                                                                            </td>
                                                                            <td>
                                                                                {
                                                                                    policyIndex === 0
                                                                                        && values.seasons.length > 1
                                                                                        ? <Button role='link' name='Delete Season' onClick={() => this.deleteSeason(values.seasons, index)} />
                                                                                        : <></>
                                                                                }
                                                                            </td>
                                                                        </tr>
                                                                    </React.Fragment>
                                                                )
                                                                )
                                                            }
                                                            {
                                                                !isObjectEmpty(errors)
                                                                && isArrayNotEmpty(errors.seasons)
                                                                && typeof (errors.seasons) !== 'string'
                                                                && errors.seasons[index]
                                                                && typeof (errors.seasons[index]) === 'string'
                                                                && <tr className={index % 2 === 0 ? 'cell-dark' : 'cell-light'} key={`season-${index}-dow-error`}>
                                                                    <td colSpan={7} className='error text-center'>
                                                                        {errors.seasons[index]}
                                                                    </td>
                                                                </tr>
                                                            }
                                                        </React.Fragment>
                                                    ))
                                            }
                                        </tbody>
                                    </table>
                                    {
                                        values.seasons.length % 2 === 0
                                        && <hr className='mt-0' />
                                    }
                                    {
                                        !isObjectEmpty(errors)
                                        && errors.seasons
                                        && typeof (errors.seasons) === 'string'
                                        && <p colSpan={7} className='error text-center'>
                                            {errors.seasons}
                                        </p>
                                    }
                                    <Button name='Add Season' onClick={() => this.addSeason(values.seasons)} />
                                </div>
                                <FormFooter
                                    form={
                                        {
                                            previous: { title: 'Hotel Policies', route: RouteConst.ROUTE_POLICIES_PAGE },
                                            next: { title: 'Pet Policy', route: RouteConst.ROUTE_PET_POLICY_PAGE }
                                        }
                                    }
                                    isSubmit
                                    submitName={FormConst.SAVE_BUTTON_TEXT}
                                    resetName={FormConst.RESET_BUTTON_TEXT}
                                    noReset
                                    submitDisabled={isSubmitting} />
                                <FormModal
                                    id='guarantee-cancel-policies-page-loading-modal'
                                    title={FormConst.MODAL_UPDATE_ACTION_TITLE}
                                    hotelInfo={this.state.hotelInfo}
                                    body={<h6>{this.state.loadingMessage}</h6>}
                                    show={this.state.isLoading}
                                    isLoadingIndicator />
                                <FormModal
                                    id='guarantee-cancel-policies-page-reset-modal'
                                    hotelInfo={this.state.hotelInfo}
                                    title={FormConst.MODAL_RESET_ACTION_TITLE}
                                    body={<h5>{FormConst.MODAL_RESET_ACTION_TEXT}</h5>}
                                    proceed={() => {
                                        this.resetFormData(resetForm)
                                    }}
                                    cancel={() => { this.setState({ showResetModal: false }) }}
                                    show={this.state.showResetModal} />
                                <FormModal
                                    id='guarantee-cancel-policies-page-error-modal'
                                    hotelInfo={this.state.hotelInfo}
                                    title={FormConst.MODAL_UPDATE_ACTION_ERROR_TITLE}
                                    body={<h5>{this.state.errorMessage}</h5>}
                                    isError
                                    cancel={() => { this.setState({ showErrorModal: false }) }}
                                    show={this.state.showErrorModal} />
                            </Form>
                        )}
                    </Formik>
                </div>
            </div>
        )
    }
}

// Sample redux dispatch
const mapStateToProps = state => {
    return {
        guaranteeCancelPolicyResponse: state.reducer.response,
        errorMessage: state.reducer.errorMessage,
        errorDescription: state.reducer.errorDescription,
        count: state.reducer.count
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onPut: (data) => dispatch(asyncMethod(FormConst.FORM_GUARANTEE_CANCEL_POLICY_NAME, actionTypes.ASYNC_ACTIONS.PUT, data))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withFormLayout(GuaranteeAndCancelPolicyWithSeasons, SideNavEntryMapping.HOTEL_POLICIES))
